import {Component, OnInit, HostBinding,} from '@angular/core';
import {LoadingService,} from '@pages/loading/loading.service';

/**
 * ローディング画面コンポーネント.
 */
@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css',],
})
export class LoadingComponent implements OnInit {
  @HostBinding('hidden')
  hidden = true;

  constructor(private loadingService: LoadingService) {}

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {
    // eslint-disable-next-line import/no-deprecated
    this.loadingService.loading$.subscribe(loading => {
      this.hidden = !loading;
      // ロード中は、本コンポーネントをかぶせてボタンを押せないようにするほかに、
      // キー操作も抑止する
      if (loading) {
        // ローディング画面コンポーネントが表示されている状態で、ショートカットキーを無効にする。
        this.enableDisableAccessKey(true);
        window.addEventListener('keydown', this.cancelKeydown, true);
      } else {
        this.enableDisableAccessKey(false); //ショートカットキーを有効にする。
        window.removeEventListener('keydown', this.cancelKeydown, true);
      }
    });
  }

  private cancelKeydown(e: KeyboardEvent): void {
    e.preventDefault();
    e.stopPropagation();
  }

  /**
   * ショートカットキーを有効・無効にする。
   * @param {boolean} disable // false:有効、true:無効
   */
  enableDisableAccessKey(disable: boolean): void {
    const targetAccesskey = 'app-root [accesskey]';
    const fixedStr = 'disabled';

    if (disable) {
      // 全てのaccesskey値の先頭に固定文字を追加して、画面内のaccesskeyを無効にする
      window.document.querySelectorAll(targetAccesskey).forEach((element) => {
        if (element instanceof HTMLElement && element.accessKey.length === 1) {
          element.accessKey = fixedStr + element.accessKey;
        }
      });
    }
    else {
      // 追加した固定文字を削除して、画面内のaccesskeyを有効にする
      window.document.querySelectorAll(targetAccesskey).forEach((element) => {
        if (element instanceof HTMLElement && element.accessKey.length > 1) {
          element.accessKey = element.accessKey.replace(fixedStr, '');
        }
      });
    }
  }

}
